export interface GoalColor {
  color: string;
  background: string;
  border: string;
}

// Goal colours keyed by the stable goal `class` slug (see public/stub/goal.json)
export const GOAL_COLOR_MAP: Record<string, GoalColor> = {
  'cultural-preservation': {color: '#ffcc00', background: '#ffcc001a', border: '#ffcc0033'},     // Cultuurbehoud
  'climate-nature-landscape': {color: '#9b3965', background: '#9b39651a', border: '#9b396533'}, // Klimaat, natuur, en landschap behoud
  'culture-and-tradition': {color: '#97a748', background: '#97a7481a', border: '#97a74833'}, // Cultuur en tradities laten zien
  'umbrella-organization': {color: '#666666', background: '#6666661a', border: '#666663'},     // Overkoepelende of Intermediaire organisatie
  'bringing-people-together': {color: '#ff9900', background: '#ff99001a', border: '#ff990033'},     // Mensen bij elkaar brengen
  'adapting-renewing-heritage': {color: '#35a9c5', background: '#35a9c51a', border: '#35a9c533'}, // Erfgoed aanpassen en vernieuwen
};

export const DEFAULT_GOAL_COLOR: GoalColor = {color: '#666', background: '#6666661a', border: '#6663'};

export function getGoalColor(goalClass: string): GoalColor {
  return GOAL_COLOR_MAP[goalClass] ?? DEFAULT_GOAL_COLOR;
}
